import { render, staticRenderFns } from "./CetificateWrapper.vue?vue&type=template&id=63e2ef9c&scoped=true&"
import script from "./CetificateWrapper.vue?vue&type=script&lang=ts&"
export * from "./CetificateWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e2ef9c",
  null
  
)

export default component.exports